import { IRoutes } from 'common/interfaces/routes';
import { PoliciesPermissionSetItems as Permission } from 'common/constants/permissions';
import { Routes } from 'constants/route.constants';
import commonMessages from 'common/messages/messages';

export const routes: IRoutes[] = [
  {
    type: 'link',
    path: Routes.PEAK_SETTINGS_INTEGRATIONS,
    message: commonMessages.integrations,
    permissions: [Permission.PEAK_SETTINGS_INTEGRATION_VIEW],
  },
  {
    type: 'link',
    path: Routes.PEAK_SETTINGS_FEE_RATES,
    message: commonMessages.feeRatesLabel,
    permissions: [Permission.PEAK_SETTINGS_FEE_RATES_VIEW],
  },
  {
    type: 'link',
    path: Routes.PEAK_SETTINGS_GENERAL,
    message: commonMessages.generalLabel,
    permissions: [Permission.PEAK_SETTINGS_GENERAL_VIEW],
  },
];

export const actionTypes = {
  // Corporation action types
  FETCH_PEAK_SETTINGS_SECTION_INFO: 'FETCH_PEAK_SETTINGS_SECTION_INFO',
  FETCH_PEAK_SETTINGS_SECTION_INFO_LOADING: 'FETCH_PEAK_SETTINGS_SECTION_INFO_LOADING',

  UPDATE_PEAK_SETTINGS_SECTION_LOADING: 'UPDATE_PEAK_SETTINGS_SECTION_LOADING',
  UPDATE_PEAK_SETTINGS_SECTION: 'UPDATE_PEAK_SETTINGS_SECTION',
  RESET_PEAK_SETTINGS_SECTION_UPDATE_ACTION_RESULT:
    'RESET_PEAK_SETTINGS_SECTION_UPDATE_ACTION_RESULT',

  // General
  PEAK_SETTINGS_PRIMARY_COLOR_LOADING: 'FETCH_PEAK_SETTINGS_PRIMARY_COLOR_LOADING',
  PEAK_SETTINGS_PRIMARY_COLOR_RESULT: 'FETCH_PEAK_SETTINGS_PRIMARY_COLOR_RESULT',
};
